import EventEmitter from 'events';

// Enable more listeners
EventEmitter.defaultMaxListeners = 20;

// Debug flag - set to true to see event logs
const debug = true;

// Create a singleton event emitter
const eventEmitter = new EventEmitter();

// Log events when debug is enabled
const originalEmit = eventEmitter.emit;
eventEmitter.emit = function(type, ...args) {
  if (debug) {
    console.log(`[Event Emitted] ${type}`, ...(args.length ? args : []));
  }
  return originalEmit.apply(this, [type, ...args]);
};

// Log when listeners are added
const originalOn = eventEmitter.on;
eventEmitter.on = function(type, listener) {
  if (debug) {
    console.log(`[Listener Added] ${type}`);
  }
  return originalOn.apply(this, [type, listener]);
};

// Event types
export const EVENT_TYPES = {
  DATA_CHANGED: 'data_changed',
  
  // Document events
  DOCUMENT_CREATED: 'document_created',
  DOCUMENT_UPDATED: 'document_updated',
  DOCUMENT_DELETED: 'document_deleted',
  DOCUMENT_AMOUNT_CHANGED: 'document_amount_changed',
  
  // Client events
  CLIENT_CREATED: 'client_created',
  CLIENT_UPDATED: 'client_updated',
  CLIENT_DELETED: 'client_deleted',
  CLIENT_STATUS_CHANGED: 'client_status_changed',
  
  // Product events
  PRODUCT_CREATED: 'product_created',
  PRODUCT_UPDATED: 'product_updated',
  PRODUCT_DELETED: 'product_deleted',
  PRODUCT_PRICE_CHANGED: 'product_price_changed',
  
  // Employee events
  EMPLOYEE_CREATED: 'employee_created',
  EMPLOYEE_UPDATED: 'employee_updated',
  EMPLOYEE_DELETED: 'employee_deleted',
  EMPLOYEE_SALARY_CHANGED: 'employee_salary_changed',
  
  // Category events
  CATEGORY_CREATED: 'category_created',
  CATEGORY_UPDATED: 'category_updated',
  CATEGORY_DELETED: 'category_deleted'
};

export default eventEmitter; 
